import { Alarm } from '@interfaces/alarm';
import { format, parseISO } from 'date-fns';

export interface AlarmFormValue {
  alarm_date:    string;
  alarm_time:    string;
  alarm_title:   string;
  alarm_message: string;
  medium:        string;
}

export function mergeAlarmDatetime(
  value: AlarmFormValue,
): Partial<Alarm> {
  const { alarm_date, alarm_time, ...rest } = value;

  return {
    ...rest,
    alarm_datetime: `${alarm_date} ${alarm_time}`,
  };
}

export function splitAlarmDatetime(isoDatetime: string): {
  date: string;
  time: string;
} {
  return {
    date: format(parseISO(isoDatetime), 'yyyy-MM-dd'),
    time: format(parseISO(isoDatetime), 'HH:mm'),
  };
}

export function formatAlarmForReadUpdate(alarm: Alarm): Partial<Alarm> {
  const [date, timePart] = alarm.alarm_datetime.split('T');
  const alarm_datetime = `${date} ${timePart.slice(0, 5)}`;

  return {
    alarm_datetime,
    alarm_message: alarm.alarm_message,
    medium: alarm.medium,
    was_read: true,
  };
}
